<template>
    <div class="d-flex" style="width: 100%;">
        <v-menu
            v-model="startTimePicker"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    :value="formattedDateStart"
                    label="Начало"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    class="mr-4"
                    hide-details
                ></v-text-field>
            </template>
            <v-date-picker
                v-model="dateStartString"
                :max="dateStartMax"
                no-title
                scrollable
                locale="ru-RU"
                :first-day-of-week="1"
                @input="updateDateStart"
            ></v-date-picker>
        </v-menu>

        <v-menu
            v-model="endTimePicker"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    :value="formattedDateEnd"
                    label="Конец"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details
                ></v-text-field>
            </template>
            <v-date-picker
                v-model="dateEndString"
                :max="dateEndMax"
                no-title
                scrollable
                locale="ru-RU"
                :first-day-of-week="1"
                @input="updateDateEnd"
            ></v-date-picker>
        </v-menu>
    </div>
</template>

<script>
    export default {
        name: 'cashReport',

        props: {
            minusDaysForStartDate: {
                type: Number,
                required: true,
            }
        },

        data() {
            return {
                startTimePicker: false,
                dateStart: new Date(),
                dateStartMax: null,
                endTimePicker: false,
                dateEnd: new Date(),
                dateEndMax: null,
            }
        },

        mounted() {
            this.dateEndMax = this.dateEnd.toISOString().substr(0, 10);
            const maxDateStart = new Date(this.dateEnd);
            maxDateStart.setDate(maxDateStart.getDate() - 1);
            this.dateStartMax = maxDateStart.toISOString().substr(0, 10);
            const tempDateStart = new Date(this.dateEnd);
            tempDateStart.setDate(tempDateStart.getDate() - (Number(this.minusDaysForStartDate) - 1));
            this.dateStart = tempDateStart;
        },

        computed: {
            formattedDateStart() {
                return this.dateStart.toLocaleDateString('ru-RU');
            },

            formattedDateEnd() {
                return this.dateEnd.toLocaleDateString('ru-RU');
            },

            dateStartString: {
                get() {
                    return this.dateStart.toISOString().substr(0, 10);
                },
                set(value) {
                    this.dateStart = new Date(value);
                }
            },

            dateEndString: {
                get() {
                    return this.dateEnd.toISOString().substr(0, 10);
                },
                set(value) {
                    this.dateEnd = new Date(value);
                }
            }
        },

        methods: {
            updateDateStart(date) {
                this.dateStart = new Date(date);
                if (this.dateStart >= this.dateEnd) {
                    this.dateEnd = new Date();
                }
            },

            updateDateEnd(date) {
                this.dateEnd = new Date(date);
                if (this.dateEnd <= this.dateStart) {
                    const tempDateStart = new Date(this.dateEnd);
                    tempDateStart.setDate(tempDateStart.getDate() - 1);
                    this.dateStart = tempDateStart;
                }
            },

            getDateBegin() {
                return this.dateStart.toISOString().substr(0, 10);
            },

            getDateEnd() {
                return this.dateEnd.toISOString().substr(0, 10);
            },
        }
    }
</script>

<style scoped>

.v-menu {
    z-index: 1000 !important;
}

</style>